import { useTranslation } from 'react-i18next';

import { Tabs } from '@treams/treams-ui';

type Props = {
	chatHistoryExact?: boolean;
	promptInstructionsExact?: boolean;
};

export default function AIWorkbenchTabs(props: Props) {
	const { t } = useTranslation();

	return (
		<Tabs.Container>
			<Tabs.Item
				title={t('settings.ai-workbench.chat_history')}
				path="/settings/workbench"
				exact={props.chatHistoryExact ?? true}
			/>
			<Tabs.Item
				title={t('settings.ai-workbench.prompt-instructions')}
				path="/settings/workbench/prompts"
				exact={props.promptInstructionsExact ?? true}
			/>
			<Tabs.Item
				title={t('settings.ai-workbench.analytics', { defaultValue: 'Analytics' })}
				path="/settings/workbench/analytics"
			/>
		</Tabs.Container>
	);
}
